
import HomePage from '../pages/home.f7.html';
import AboutPage from '../pages/about.f7.html';
import FormPage from '../pages/form.f7.html';
// import MapaPage from '../pages/mapa.f7.html';
import Login from '../pages/login.f7.html';
import ListadoUsados from '../pages/usadoslistado.f7.html';
import UsadosABM from '../pages/usadosabm.f7.html';
import UsadosCheckList from '../pages/usadoschecklist.f7.html';
import UsadosImagenes from '../pages/usadosimagenes.f7.html';


import DynamicRoutePage from '../pages/dynamic-route.f7.html';
import RequestAndLoad from '../pages/request-and-load.f7.html';
import NotFoundPage from '../pages/404.f7.html';

import { usadosFunciones } from "./usadosFunciones";

var routes = [
  {
    path: '/',
    // component: Login,
    component: ListadoUsados,
  //   on:{
  //     pageBeforeIn: function (event, page) {
  //         console.log('pageBeforeIn - Listado de Vehiculos');
  //     },
  //     pageAfterIn: function (event, page) {
  //         console.log('pageAfterIn - Listado de Vehiculos');
  //     },
  //     pageInit: function (event, page) {
  //         console.log('pageInit - Listado de Vehiculos');
  //     },
  //     pageBeforeRemove: function (event, page) {
  //         console.log('pageBeforeRemove - Listado de Vehiculos');
  //     },
  //     pageMounted: function (event, page) {
  //         console.log('pageMounted - Listado de Vehiculos');
  //     },
  // }
  },
  {
    path: '/about/',
    component: AboutPage,
  },
  {
    path: '/logout/',
    component: AboutPage,
  },
  {
    path: '/mapa/',
    // component: MapaPage,
  },
  {
    path: '/form/',
    component: FormPage,
  },
  {
    name: 'abm',
    path: '/abm/',
    component: UsadosABM,
  },
  {
    path: '/checklist/',
    component: UsadosCheckList,
  },
  {
    path: '/usadosimagenes/',
    component: UsadosImagenes,
  },


  {
    path: '/dynamic-route/blog/:blogId/post/:postId/',
    component: DynamicRoutePage,
  },
  {
    path: '/eliminarImagen/:vehiculoId/:imagenId/',
    async:function({router, to, resolve }){
      var app = router.app;
      let usados = new usadosFunciones();
      
      var imagenId = to.params.imagenId;
      var vehiculoId = to.params.vehiculoId;

      app.dialog.confirm(
        'Confirma eliminar la imagen seleccionada?', 
        'Eliminar Imagen', 
        function (params) {
          usados.eliminarImagen(app, imagenId, router);  
          resolve(
            {
              url: '/usadosimagenes/?id_vehiculo=' + vehiculoId,
            },
            {
              reloadCurrent: true,
              animate: true
              
            }
          );  
        },
        function () {
          resolve(
            {
              url: '/usadosimagenes/?id_vehiculo=' + vehiculoId,
            },
          );
        })

      
    }
  },
  {
    path: '/editarImagen/:vehiculoId/:imagenId/',
    async:function({ router, to, resolve }){
      var app = router.app;
      let usados = new usadosFunciones();
      var imagenId = to.params.imagenId;
      var vehiculoId = to.params.vehiculoId;
      usados.editarImagen(imagenId);
      resolve(
        {
          url: '/usadosimagenes/?id_vehiculo=' + vehiculoId,
        },
      );
    }
  },
  {
    path: '/request-and-load/user/:userId/',
    async: function ({ router, to, resolve }) {
      // App instance
      var app = router.app;

      // Show Preloader
      app.preloader.show();

      // User ID from request
      var userId = to.params.userId;

      // Simulate Ajax Request
      setTimeout(function () {
        // We got user data from request
        var user = {
          firstName: 'Vladimir',
          lastName: 'Kharlampidi',
          about: 'Hello, i am creator of Framework7! Hope you like it!',
          links: [
            {
              title: 'Framework7 Website',
              url: 'http://framework7.io',
            },
            {
              title: 'Framework7 Forum',
              url: 'http://forum.framework7.io',
            },
          ]
        };
        // Hide Preloader
        app.preloader.hide();

        // Resolve route to load page
        resolve(
          {
            component: RequestAndLoad,
          },
          {
            props: {
              user: user,
            }
          }
        );
      }, 1000);
    },
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;